import { TradeSettings, UpdateTradeSettingsBody } from 'common/models';
import http from 'core/services/api';

class SettingsRepository {
  getTradeSettings = async () => {
    return http.fetch((axios, signal) =>
      axios.get<TradeSettings>('/accounts/settings', { signal })
    );
  };

  updateTradeSettings = async (body: UpdateTradeSettingsBody) => {
    return http.fetch((axios, signal) =>
      axios.patch<TradeSettings>('/accounts/update-settings', body, {
        signal,
      })
    );
  };
}

export const settingsRepository = new SettingsRepository();
